import translations from './translations'

translations.add('pt', {
    threeDigitsDescription: 'Um grupo de três dígitos na parte de trás do cartão',
    fourDigitsDescription: 'Grupo de quatro dígitos na parte da frente à direita',
    cvcCode: 'CSC/CVV'
})
